import type { ReactNode } from 'react';

import { LanguageSelector } from 'src/app/components/Elements/LanguageSelector';
import MarketingPageSection from 'src/app/components/Elements/MarketingPageSection';

import { ContentContainer } from './styles';

type ClearRxLayoutProps = {
  children: ReactNode;
};

export const ClearRxLayout = ({ children }: ClearRxLayoutProps) => {
  return (
    <MarketingPageSection>
      <ContentContainer>
        <LanguageSelector />
        {children}
      </ContentContainer>
    </MarketingPageSection>
  );
};
